module.exports = __webpack_public_path__ + "static/media/devMountain.eb5df0e3.png";